<mat-toolbar class="menu-toolbar">
  <nav class="menu-toolbar__nav-left">
    @if (isMainMenuBackoffice) {
      <img
        class="menu-toolbar__logo"
        src="assets/img/toll-management.svg"
        alt="Logo Pedágio"
        />
    }
    @else{
    <section class="dropdown menu-toolbar__menu-container">
      @if (menuActive && (menuActive.children && menuActive.children.length > 0)) {
        @for (item of menuActive.children; track item) {
          <button
            class="dropdown-toggle menu-toolbar__menu-links"
            [ngClass]="{ active: isMenuActivePath(item.path, true, item) }"
            id="menu-links-{{ generateClassName(item) }}"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
              [routerLink]="
                item.children && item.children.length > 0
                  ? profileRootPath + item.children[0].path
                  : profileRootPath + item.path
              "
            (mouseenter)="openMenuSubitems(item.title)"
            >
            {{ item.title | translate }}
          </button>
          @if (menuSubitemsActive == item.title && item.children && item.children.length > 0) {
            <div
                class="dropdown-menu menu-toolbar__submenu-container submenu-{{
                  generateClassName(item)
                }}"
              (mouseleave)="openMenuSubitems('')"
              >
              <span class="{{ handleClassByMenusIds(item) }}"></span>
              @for (subitem of item.children!; track subitem) {
                <button
                  class="dropdown-item menu-toolbar__submenu-links"
                  [routerLink]="profileRootPath + subitem.path"
                  >
                  {{ subitem.title | translate }}
                </button>
              }
            </div>
          }
        }
      }
    </section>
  }
</nav>

<nav class="menu-toolbar__nav-right">
  @if (userProfile === profileType.BACKOFFICE && !isMainMenuBackoffice) {
    <button
      class="menu-toolbar__menu-links"
      id="btn-main-menu-backoffice"
      data-e2e="btn-main-menu-backoffice"
      [routerLink]="mainMenuBackofficePath"
      >
      {{ "Menu inicial" }}
    </button>
  }

  @if (hasMultipleProfile()) {
    <button
      class="menu-toolbar__menu-links"
      id="btn-change-profile"
      data-e2e="btn-change-profile"
      (click)="changeProfile()">
      {{ "Trocar portal" }}
    </button>
  }

  <button
    class="menu-toolbar__menu-links"
    id="btn-logout"
    data-e2e="btn-logout"
    (click)="logout()"
    >
    <img src="assets/icons/login-logout-icon.svg" alt="logout icon"/>
    {{ "Sair" }}
  </button>
</nav>
</mat-toolbar>
